<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_label_search')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form :model="form" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amzReplenishmentNo') || '亚马逊补货单号'"
            >
              <el-input
                v-model.trim="form.amzReplenishmentNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_planNo') || '补货计划编号'">
              <el-input
                v-model.trim="form.planNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_amzPeriodTitle') || '补货计划标题'"
            >
              <el-input
                v-model="form.amzPeriodTitle"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amazonStoreRegion') || '店铺区域'"
            >
              <dict-select
                v-model="form.listAmazonStoreRegion"
                url="/ecom//amz/market/dictSelect"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                filterable
                multiple
                clearable
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_skuSalesChannel') || '产品售卖渠道'"
            >
              <dict-select
                v-model="form.skuSalesChannel"
                url="/sys/common/dict/system"
                :body="{ dictType: 'skuSalesChannel' }"
                :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
                clearable
                filterable
                style="width:100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_shippingDate') || '预计发运日期'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shippingDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.shippingDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item :label="$l('form_label_etaDate') || '预计到货日期'">
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.etaDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.etaDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <br />
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listReplenishmentStatus: ['N'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
